import React from "react";
import spayd from 'features/shared/spayd/spayd';
import QRCode from "qrcode.react";
import PaymentDescription from "features/shared/spayd/PaymentDescription";
import QRPaymentDTO from "../dtos/QRPaymentDTO";

interface Props {
  qrPayment: QRPaymentDTO;
  size?: number;
  includeMargin?: boolean;
  bgColor?: string;
  fgColor?: string;
  level?: "L" | "M" | "Q" | "H";
}

/*const paymentDescTest:PaymentDescription = {
  acc: "CZ5003000000000117164033",
  altAcc: [],
  am: "11020.00",
  cc: "CZK",
  //rf: null,
  rn: "ARMEX ENERGY, a.s.",
  dt: new Date(2021, 2, 26),
  //pt: null,
  msg: "QR platba - Úhrada dokladu č. ZF2020001608",
  //crc32: null,
  // xpe: null,
  xvs: "7200007353",
  //xss: null,
  xks: "0308",
  //xid: null
};*/

const PaymentQRCode = (props: Props) => {
  // private props
  let spaydString:string = "";

  // helpers  
  const isSuccessConvertToSpayd = ():boolean => {
    let isSuccess = false;
    let paymentDesc = convertQRPaymentToPaymentDescripiton();
    
    try {
      spaydString = spayd(paymentDesc);
      isSuccess = true;
    } catch (error) {
      console.log(error);
    }

    return isSuccess;
  }

  const convertQRPaymentToPaymentDescripiton = () => {
    let paymentDesc:any = {};
    
    for (const [key, value] of Object.entries(props.qrPayment)) {
      if (value !== null) {
        paymentDesc[key] = value;
      }
    }

    return paymentDesc as PaymentDescription;
  };

  // render
  if (isSuccessConvertToSpayd() && spaydString !== "") {
    return (
      <QRCode
        value={spaydString}
        size={props.size}
        includeMargin={props.includeMargin}
        bgColor={props.bgColor}
        fgColor={props.fgColor}
        level={props.level}
      />
    ); 
  } else {
    return null;
  }
};

export default PaymentQRCode;
